<template>
    <div v-if="intervention">
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <intervention-header :intervention="intervention" @toggle-interventions-list="toggleInterventionsList"></intervention-header>
            </div>
        </div>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <div class="tabs-layout">
                    <md-tabs @md-changed="changeTab" md-active-tab="tab-infos-inter">
                        <md-tab :id="tabs[0].id" :md-label="tabs[0].tabTitle">
                            <div class="md-layout md-gutter" v-if="tabs[0].active">
                                <div class="md-layout-item md-size-50">
                                    <intervention-client-informations :site="intervention.site" :client="intervention.site.client"></intervention-client-informations>
                                    <intervention-informations :intervention="intervention"></intervention-informations>
                                </div>
                                <div class="md-layout-item md-size-50">
                                    <intervention-planification :intervention="intervention" @updated="getInterventionDetails"></intervention-planification>
                                    <intervention-notes :site="intervention.site" :client="intervention.site.client"></intervention-notes>
                                    <intervention-history :logs="intervention.logs"></intervention-history>
                                </div>
                            </div>
                        </md-tab>
                        <md-tab :id="tabs[1].id" :md-label="tabs[1].tabTitle">
                            <intervention-devices v-if="tabs[1].active" :intervention="intervention"></intervention-devices>
                        </md-tab>
                        <md-tab :id="tabs[2].id" :md-label="tabs[2].tabTitle" :md-disabled="!canSeeAllTabs">
                            <intervention-report @update-report="updateReport" v-if="tabs[2].active" :intervention="intervention"></intervention-report>
                        </md-tab>
                        <md-tab :id="tabs[3].id" :md-label="tabs[3].tabTitle" :md-disabled="!canSeeAllTabs">
                            <intervention-signature @update-report="updateReport" v-if="tabs[3].active" :intervention="intervention"></intervention-signature>
                        </md-tab>
                        <md-tab :id="tabs[4].id" :md-label="tabs[4].tabTitle" :md-disabled="!canSeeAllTabs">
                            <intervention-pdf-reports v-if="tabs[4].active" :intervention="intervention"></intervention-pdf-reports>
                            <intervention-documents v-if="tabs[4].active" :intervention="intervention"></intervention-documents>
                        </md-tab>
                    </md-tabs>
                </div>
            </div>
        </div>

        <md-drawer md-right :md-active.sync="showPanel">
            <intervention-panel v-if="showPanel" :intervention="intervention">
            </intervention-panel>
        </md-drawer>
    </div>
</template>

<script>
import InterventionHeader from "@/pages/Planning/Intervention/components/details/Header";
import InterventionPanel from "@/pages/Planning/Intervention/components/details/Panel";
import InterventionClientInformations from "@/pages/Planning/Intervention/components/details/ClientInformations";
import InterventionInformations from "@/pages/Planning/Intervention/components/details/Informations";
import InterventionPlanification from "@/pages/Planning/Intervention/components/details/Planification";
import InterventionNotes from "@/pages/Planning/Intervention/components/details/Notes";
import InterventionHistory from "@/pages/Planning/Intervention/components/details/History";
import InterventionDevices from "@/pages/Planning/Intervention/components/details/DevicesReports";
import InterventionReport from "@/pages/Planning/Intervention/components/details/Report";
import InterventionSignature from "@/pages/Planning/Intervention/components/details/Signature";
import InterventionPdfReports from "@/pages/Planning/Intervention/components/details/PdfReports";
import InterventionDocuments from "@/pages/Planning/Intervention/components/details/Documents";


export default {
    name: "InterventionDetails",
    components: {
        InterventionHeader,
        InterventionPanel,
        InterventionClientInformations,
        InterventionInformations,
        InterventionPlanification,
        InterventionNotes,
        InterventionHistory,
        InterventionDevices,
        InterventionReport,
        InterventionSignature,
        InterventionPdfReports,
        InterventionDocuments
    },
    data() {
        return {
            intervention: null,
            tabs: [
                { id: 'tab-infos-inter', tabTitle: 'Infos Intervention', active: true },
                { id: 'tab-devices', tabTitle: 'Dispositifs', active: false },
                { id: 'tab-rapport', tabTitle: 'Rapport', active: false },
                { id: 'tab-signature', tabTitle: 'Signature', active: false },
                { id: 'tab-docs', tabTitle: 'Documents', active: false },
            ],
            showPanel: false
        };
    },
    methods: {
        async getInterventionDetails() {
            const { data } = await this.$store.dispatch('interventions/getInterventionDetails', {
                id: this.$route.params.id
            })
            this.intervention = data
        },
        changeTab(id = 'tab-infos-inter') {
            this.tabs.map(tab => tab.active = false)
            let activeTab = this.tabs.find(tab => tab.id === id)
            activeTab.active = true
        },
        toggleInterventionsList() {
            this.showPanel = !this.showPanel
        },
        updateReport (e) {
            this.intervention.report = e
        }
    },
    mounted() {
        this.getInterventionDetails()
    },
    created() {
        bus.$emit('minimise-sidebar');
    },
     computed: {
        canSeeAllTabs () {
            return (this.intervention.status_id === 6 || !this.$moment(this.intervention.planningable.start_date).isAfter(this.$moment()))
        }
     }
}
</script>

<style lang="scss" scoped>
</style>
